<template>
	<div class="content background1" style="display:flex">
		<div class="tableBox9" v-if="!qrCodeShow">
			<div class="tableMes">
				<div class="table">
					<el-tabs v-model="activeNameTree" type="card" @tab-click="handleClickTree">
						<el-tab-pane :label="$t('label_429')" name="first">
							<tree :dataTree="treeData" @getDeviceMes="getDeviceMes"></tree>
						</el-tab-pane>
						<el-tab-pane :label="this.$t('label_161')" name="second">
							<tree :dataTree="treeData2" @getDeviceMes="getDeviceMes"></tree>
						</el-tab-pane>
					</el-tabs>
				</div>
			</div>
		</div>
		<div class="right-showbtn" @click="showBtn">
			<div class="right-showbtn-qrcode-background">
				<i v-if="qrCodeShow" class="el-icon-arrow-right" style="margin-top: 32px; margin-left: -3px; color: #FFFFFF;"></i>
				<i v-if="!qrCodeShow" class="el-icon-arrow-left" style="margin-top: 32px; margin-left: -3px; color: #FFFFFF;"></i>
			</div>
		</div>
		<div class="tableBox10" :style="{'padding':width=='0px'?'60px 0px 0px 0px':'60px 0px 0px 350px '}">
			<div class="tableMes">
				<div class="table" style="padding: 0">
					<div class="treeMes" v-if="getTreeMes=='1'">
						<p class="title"><span class="spot">{{'<' + deviceDetailMes.name + '>'}}</span>{{$t('label_699')}}</p>
						<div class="chooseBox" style="height: 110px;">
							<div class="selectBox a" style="height:0px;width: 100%; display: table;">
								<el-tabs v-model="activeNameSpot" @tab-click="handleClickSpot">
									<el-tab-pane :label="$t('label_91')" name="spot" v-if="MenuRoleList.indexOf('123')>=0"></el-tab-pane>
									<!-- <el-tab-pane :label="按故障原因统计" name="pro" v-if="MenuRoleList.indexOf('125')>=0"></el-tab-pane> -->
								</el-tabs>
							</div>
							<div class="selectBox" style="width: 100%;">
								<div>
									<div v-if="activeNameSpot=='spot'">
										<div class="selectChoose">
											<div class="selectText" style="margin-left: 18px;">
												<p>{{$t('label_593')}}</p>
											</div>
											<div class="select" style="width:350px">
												<el-input v-model="searchParam.name" clearable></el-input>
											</div>
										</div>
									</div>
									<div v-if="activeNameSpot=='pro'">
										<div class="selectChoose">
											<div class="selectText" style="margin-left: 18px;">
												<p>{{$t('label_389')}}</p>
											</div>
											<div class="select" style="width:350px">
												<el-input v-model="faultReason" clearable></el-input>
											</div>
										</div>
									</div>
								</div>
								<div>
									<div class="selectChoose">
										<div class="selectText">
											<p>{{$t('label_73')}}</p>
										</div>
										<div class="select" style="width:350px">
											<el-date-picker v-model="Readytime" type="daterange" format="yyyy-MM-dd" value-format='yyyy-MM-dd'
											 :range-separator="$t('label_264')" :start-placeholder="$t('label_329')" :end-placeholder="$t('label_388')" :clearable="false">
											</el-date-picker>
										</div>
									</div>
								</div>
                <div class="buttonBox buttonBoxRight" style="bottom: 5px">
                  <div>
                    <div class="chooseButton sendButton" @click="search({pageNum: 1,pageSize:pageSize})"><i class="el-icon-search"></i>{{$t('btn_2')}}</div>
                  </div>
                </div>
							</div>
						</div>
						<div class="spotMes3Box" v-if="activeNameSpot=='spot'" style="position:relative;height: calc(100% - 160px)">
							<div class="tableMin" style="height: 100%;">
								<div class="tableList" style="height: 100%;padding: 5px 20px">
									<div class="buttonBox" style="float: left">
										<div>
											<div class="chooseButton searchButton" @click="exportExcel" v-if="MenuRoleList.indexOf('162')>=0" style="margin-left: 1px;">
												<i class="el-icon-download"></i>{{$t('btn_10')}}
											</div>
										</div>
									</div>
									<div class="tableNum">
										<p class="p5" style="color: #000000">{{statusNumList.num0}}</p>
										<p class="p5" style="color: #e60000">{{statusNumList.num1}}</p>
										<p class="p5" style="color: #e60000">{{statusNumList.num2}}</p>
										<p class="p5" style="color: #e60000">{{statusNumList.num3}}</p>
										<p class="p5" style="color: #ffb400">{{statusNumList.num4}}</p>
										<p class="p5" style="color: #e60000">{{statusNumList.num5}}</p>
										<p class="p5" style="color: #ffb400">{{statusNumList.num6}}</p>
										<p class="p5" style="color: #3fb393">{{statusNumList.num7}}</p>
										<p class="p5" style="color: #aeaeae">{{statusNumList.num8}}</p>
									</div>
									<el-table :empty-text="$t('label_357')"  ref="singleTable" :data="tableData1" highlight-current-row border @current-change="handleCurrentChangeTreeTime"
									 style="width: 100%;margin: 10px 0" height="85.9%" :header-cell-style="{'background-color': '#45494f','color': '#ffffff',}"
									 @row-click="handler">
										<el-table-column header-align="center" align="center" :label="$t('label_369') + '.'" type="index" :index="getIndex" width="50">
										</el-table-column>
										<el-table-column prop="deviceName" :label="$t('label_593')" align="center" width="300">
											<template slot-scope="scope">
												<p class="tableMiTitle">
													{{scope.row.superior}}<br>
													{{scope.row.name}}<br>
													{{scope.row.code}}
												</p>
											</template>
										</el-table-column>
										<el-table-column prop="num0" :label="$t('label_507')" align="center">
											<template slot-scope="scope">
												<p >{{scope.row.num0}}</p>
											</template>
										</el-table-column>
										<el-table-column prop="num1" :label="$t('label_299')" align="center">
											<template slot-scope="scope">
												<p :class="scope.row.num1>0?'louNum':''">{{scope.row.num1}}</p>
											</template>
										</el-table-column>
										<el-table-column prop="num2" :label="$t('label_303')" align="center">
											<template slot-scope="scope">
												<p >{{scope.row.num2}}</p>
											</template>
										</el-table-column>
										<el-table-column prop="num3" :label="$t('label_307')" align="center">
											<template slot-scope="scope">
												<p >{{scope.row.num3}}</p>
											</template>
										</el-table-column>
										<el-table-column prop="num4" :label="$t('label_311')" align="center">
											<template slot-scope="scope">
												<p :class="scope.row.num4>0?'louNum':''">{{scope.row.num4}}</p>
											</template>
										</el-table-column>
										<el-table-column prop="num5" :label="$t('label_314')" align="center">
											<template slot-scope="scope">
												<p >{{scope.row.num5}}</p>
											</template>
										</el-table-column>
										<el-table-column prop="num6" :label="$t('label_318')" align="center">
											<template slot-scope="scope">
												<p >{{scope.row.num6}}</p>
											</template>
										</el-table-column>
										<el-table-column prop="num7" :label="$t('label_829')" align="center">
											<template slot-scope="scope">
												<p >{{scope.row.num7}}</p>
											</template>
										</el-table-column>
										<el-table-column prop="num8" :label="$t('label_326')" align="center">
											<template slot-scope="scope">
												<p >{{scope.row.num8}}</p>
											</template>
										</el-table-column>
									</el-table>
									<Page class="item" ref="pageModel" :total="pageCount" :display="pageSize" :pagegroup="3" :currentspage="1"
									 @parentMethod="search"></Page>
								</div>
							</div>
						</div>
						<div class="spotMes3Box"  v-if="activeNameSpot=='pro'" style="margin-top: 0;position:relative;height: calc(100% - 160px)">
							<div style="height: 100%;">
								<div class="tableList" style="height: 100%;">
									<div class="buttonBox" style="float: left">
										<div>
											<div class="chooseButton searchButton" @click="excel" v-if="MenuRoleList.indexOf('126')>=0" style="margin-left: 1px;margin-bottom: 14px;" >
												<i class="el-icon-download"></i>{{$t('btn_10')}}
											</div>
										</div>
									</div>
									<div class="tableNum">
										<p class="p6">{{statusNumList2.deviceCountNum}}</p>
										<p class="p6">{{statusNumList2.repairCountNum}}</p>
										<p class="p6">{{statusNumList2.retentionCountTime}}</p>
										<p class="p6">{{statusNumList2.repairCountTime}}</p>
									</div>
									<el-table :empty-text="$t('label_357')" ref="singleTable2" :data="tableDataInfo" highlight-current-row border
									 style="width: 100%;"  height="86%" :header-cell-style="{'background-color': '#45494f','color': '#ffffff',}"
									 @row-click="handler">
										<el-table-column header-align="center" align="center" :label="$t('label_369') + '.'" type="index" :index="getIndex" width="50">
										</el-table-column>
										<el-table-column prop="faultReason" :label="$t('label_389')" align="center" width="200">
											<template slot-scope="scope">
												<p>
													{{scope.row.faultReason}}
												</p>
											</template>
										</el-table-column>
										<el-table-column prop="deviceNum" :label="$t('故障设备数量')" align="center">
											<template slot-scope="scope">
												<p>{{scope.row.deviceNum}}</p>
											</template>
										</el-table-column>
										<el-table-column prop="repairNum" :label="$t('维修次数')" align="center">
											<template slot-scope="scope">
												<p>{{scope.row.repairNum}}{{$t('label_207')}}</p>
											</template>
										</el-table-column>
										<el-table-column prop="retentionTime" :label="$t('平均故障时长')" align="center">
											<template slot-scope="scope">
												<p>{{scope.row.retentionTime}}{{$t('label_534')}}</p>
											</template>
										</el-table-column>
										<el-table-column prop="repairTime" :label="$t('平均维修时长')" align="center">
											<template slot-scope="scope">
												<p>{{scope.row.repairTime}}{{$t('label_534')}}</p>
											</template>
										</el-table-column>
									</el-table>
									<Page class="item" ref="pageModel2" :total="pageCount" :display="pageSize" :pagegroup="3" :currentspage="1"
									 @parentMethod="search"></Page>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<exportMes :exportTitle="exportTitle" :exportData="tableDataTreeTimeExport" :exportList="exportList" ref="exportBox"></exportMes>
	</div>
</template>

<script>
	import "@/assets/css/map/map.css"
	import "@/assets/css/common/spot.css"
	import Page from "@/components/common/page";
	import TimePage from "@/assets/js/timePage/timePage.js";
	import utils from '@/utils/utils'
	import tree from "@/components/list/tree/maintainTree";
	import maintenance from "@/assets/js/maintenance/maintenance.js";
	import malfunction from "@/assets/js/malfunction/malfunction.js";
	import exportMes from "@/components/list/export/export";
	export default {
		name: 'spotCountPage',
		components: {
			Page,
			tree,
			exportMes,
		},
		data() {
			return {
				exportTitle: this.$t('label_699'),
				exportList: [{
						column: 'superior',
						title: this.$t('label_593'),
						headerAlign: 'center',
						align: 'center',
						width: '200px'
					}, {
						column: 'num0',
						title: this.$t('label_507'),
						headerAlign: 'center',
						align: 'center',
						width: '200px'
					}, {
						column: 'num1',
						title: this.$t('label_299'),
						headerAlign: 'center',
						align: 'center',
						width: '200px'
					}, {
						column: 'num2',
						title: this.$t('label_303'),
						headerAlign: 'center',
						align: 'center',
						width: '200px'
					},
					{
						column: 'num3',
						title: this.$t('label_307'),
						headerAlign: 'center',
						align: 'center',
						width: '200px'
					},
					{
						column: 'num4',
						title: this.$t('label_311'),
						headerAlign: 'center',
						align: 'center',
						width: '200px'
					},
					{
						column: 'num5',
						title: this.$t('label_314'),
						headerAlign: 'center',
						align: 'center',
						width: '200px'
					},
					{
						column: 'num6',
						title: this.$t('label_318'),
						headerAlign: 'center',
						align: 'center',
						width: '200px'
					},
					{
						column: 'num7',
						title: this.$t('label_829'),
						headerAlign: 'center',
						align: 'center',
						width: '200px'
					},
					{
						column: 'num8',
						title: this.$t('label_326'),
						headerAlign: 'center',
						align: 'center',
						width: '200px'
					},
				],
				tableDataTreeTimeExport: [],
				name: '',
				faultReason: '',
				pageNum: 1,
				pageSize: 10,
				pageCount: 0,
				Readytime: '',
				getTreeMes: '1',
				checked: false,
				dialogSpotResult: false,
				dialogSpotTimeEdit: false,
				height: 480,
				tableDataTree: [],
				MenuRoleList: [],
				treeData: {
					dataDevice: [],
					searchShow: true,
					statusShow: false,
					statusListShow: true,
					cardShow: true,
					dataAll: true,
					funtoGetMes: '2'
				},
				treeData2: {
					dataDevice: [],
					searchShow: true,
					statusShow: false,
					statusListShow: true,
					cardShow: true,
					dataAll: true,
					funtoGetMes: '3'
				},
				tableData1: [],
				tableDataInfo: [],
				activeNameTree: 'second',
				activeNameSpot: 'spot',
				statusNumList: {},
				statusNumList2: {},
				type: '',
				id: '',
				deviceDetailMes: {},
				searchParam:{
					name:'',
					faultReason:'',
				},
				width: '340px',
				qrCodeShow: false,
			}
		},
		methods: {
			exportClick() {
				this.$refs.exportBox.setExportExcel();
			},
			handleClickSpot(tab, event) {
				this.search({
					pageNum: 1,
					pageSize: this.pageSize,
				})
			},
			getIndex(index) {
				return (this.pageNum - 1) * this.pageSize + index + 1
			},
			handler(row) {
				this.type = 1;
				this.id = row.equipmentId;
			},
			getDeviceMes(data) {
				if (data.name == this.$t('label_272')) {
				  this.exportTitle = this.$t('label_699') + utils.getDayFormatDateWithoutSeperator() + this.$t('label_272');
					this.deviceDetailMes = {
					  name: ''
          };
					if(this.activeNameTree='first'){
						this.type = 0;
						this.id = '';
					}else{
						this.type = 2;
						this.id = '';
					}
					this.search({
						pageNum: 1,
						pageSize: this.pageSize,
					});
				} else {
					this.type = data.type;
					this.id = data.id;
					this.name = data.name;
					this.deviceDetailMes = data;
          this.exportTitle = this.$t('label_699') + utils.getDayFormatDateWithoutSeperator() + this.deviceDetailMes.name;
					this.search({
						pageNum: 1,
						pageSize: this.pageSize,
					});
				}
			},
			handleClose() {
				this.dialogDeviceSpot = false;
				this.dialogSpotResult = false;
				this.dialogSpotBatchTimeEdit = false;
			},
			handleCurrentChangeTree(info) {
				this.tableDataTreeInfo = info;
			},
			tableDataTreeInfoEdit() {
				if (Object.keys(this.tableDataTreeInfo).length > 0) {
					this.dialogDeviceSpot = true;
					this.tableDataTreeEdit = this.tableDataTreeInfo
				} else {
					utils.messageAlert(this.$t('input_38'), this.$t('label_358'), this.$t('label_100'));
				}
			},
			handleCurrentChangeTreeTime(info) {
				this.tableInfo = info;
				this.id = info.id;
			},
			handleClickTree(tab, event) {
				this.getTreeMes = '1';
				this.deviceDetailMes = {
          name: ''
        };
				if(this.activeNameTree='first'){
					this.type = 0;
					this.id = '';
				}else{
					this.type = 2;
					this.id = '';
				}
				this.search({
					pageNum: 1,
					pageSize: this.pageSize,
				});
			},
			search(param) {
				var dataParam = {
					beginTime: this.Readytime[0] + ' 00:00:00',
					endTime: this.Readytime[1] + ' 23:59:59',
					name: this.searchParam.name,
					faultReason: this.faultReason,
					type: this.type,
					id: this.id,
				}
				var newParam = Object.assign(param, dataParam);
				this.pageNum = newParam.pageNum;
				this.pageSize = newParam.pageSize;
				if (this.activeNameSpot == 'pro') {
					this.searchPage2(newParam);
					this.searchStauts2(newParam);
				} else {
					this.searchPage(newParam);
					this.searchStauts(newParam);
					this.export(newParam);
				}
			},
			searchPage(param) {
				malfunction.pageCount(param).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.tableData1 = data.data.records
						this.pageSize = data.data.size;
						this.pageCount = data.data.total;
						this.pageNum = data.data.current;
            this.$refs['pageModel'].setCurrent(this.pageNum);
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			searchPage2(param) {
				malfunction.pageReasonCount(param).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.tableDataInfo = data.data.records
						this.pageSize = data.data.size;
						this.pageCount = data.data.total;
						this.pageNum = data.data.current;
						this.$refs['pageModel2'].setCurrent(this.pageNum);
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			searchStauts(param) {
				malfunction.pageCountAll(param).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.statusNumList = data.data
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			searchStauts2(param) {
				malfunction.excelReasonCount(param).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.statusNumList2 = data.data
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			export (param) {
				malfunction.pageCountExcel(param).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.tableDataTreeTimeExport = data.data;
						for (var i = 0; i < this.tableDataTreeTimeExport.length; i++) {
							let element = this.tableDataTreeTimeExport[i];
              this.tableDataTreeTimeExport[i].superior = element.superior + ' ' + element.name + ' ' + element.code
						}
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			excel() {
				if (this.tableInfoid != '' && this.tableInfo.id != null && this.type != '' && this.type != null) {
					if (this.activeNameSpot == 'pro') {
						window.location.href = this.$store.getters.getPostUrl + 'mes/equipmentMaintainRecord/excel2?time=' + this.Readytime[0]
							.substring(0, 4) + "&type=" + this.type + "&name=" + this.name + "&id=" + this.tableInfo.id;
					} else {
						window.location.href = this.$store.getters.getPostUrl + 'mes/equipmentMaintainRecord/excel1?time=' + this.Readytime[0]
							.substring(0, 4) + "&type=" + this.type + "&id=" + this.tableInfo.id;
					}
				} else {
					utils.messageAlert(this.$t('msg_226'), this.$t('label_358'), this.$t('label_100'));
				}
			},
			getNowTime() {
				let zeroTime = new Date();
				let Months = zeroTime.getMonth() + 1 < 10 ? '0' + (zeroTime.getMonth() + 1) : zeroTime.getMonth() + 1; //月份从0开始，因此要+1
				let Dates = zeroTime.getDate() < 10 ? '0' + zeroTime.getDate() : zeroTime.getDate()
				let now = zeroTime.getFullYear() + '-' + Months + '-' + Dates;
				return now;
			},
			getBeforeTime() {
				var time = (new Date).getTime() - 24 * 60 * 60 * 1000;
				let zeroTime = new Date(time);
				let Months = zeroTime.getMonth() + 1 < 10 ? '0' + (zeroTime.getMonth() + 1) : zeroTime.getMonth() + 1; //月份从0开始，因此要+1
				let Dates = zeroTime.getDate() < 10 ? '0' + zeroTime.getDate() : zeroTime.getDate()
				let now = zeroTime.getFullYear() + '-' + Months + '-' + Dates;
				return now;
			},
			showBtn() {
				this.qrCodeShow = !this.qrCodeShow;
				if (this.qrCodeShow) {
					this.width = "0px";
				} else {
					this.width = "340px";
				}
			},
      exportExcel() {
        let dataParam = {
          beginTime: this.Readytime[0] + ' 00:00:00',
          endTime: this.Readytime[1] + ' 23:59:59',
          name: this.searchParam.name,
          faultReason: this.faultReason,
          type: this.type,
          id: this.id,
        }
        malfunction.countExport(dataParam).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          let link = document.createElement('a')
          link.href = url
          link.download = decodeURIComponent(response.headers['content-disposition'].split('fileName=')[1])
          link.click()
          URL.revokeObjectURL(url)
        })
      }
		},
		created() {
			this.Readytime = [this.getBeforeTime(), this.getNowTime()]
			this.search({
				pageNum: 1,
				pageSize: this.pageSize,
			});
			this.MenuRoleList = this.$store.getters.getMenu;
		}
	}
</script>

<style>
	.maintainBox {
		width: 100%;
	}

	.a .el-tabs .el-tabs__content {
		height: 0px;
	}
	.right-showbtn-qrcode-background {
		/* position: absolute; */
		width: 10px;
		height: 80px;
		background-color: #9c9c9c;
		border-top-right-radius: 10px;
		border-bottom-right-radius: 10px;
		margin: auto;
	}
	.right-showbtn {
		width: 10px;
		height: 100%;
		display: flex;
		position: relative;
		z-index: 100000;
	}
</style>



// WEBPACK FOOTER //
// src/pages/malfunction/malfunctionCountPage.vue